export default {
    parts: [
        'container',
        'content',
        'info',
        'name',
        'address',
        'hours',
        'availability',
        'ctas',
        'cta'
    ],
    baseStyle: (props) => ({
        container: {
            position: 'absolute',
            bottom: '0',
            width: '100%',
            backgroundColor: 'white',
        },
        content: {
            display: 'flex',
            alignItems: 'start',
            justifyContent: 'space-between',
            gap: 4,
            p: 4,
            pb: 0
        },
        info: {
            marginBottom: 3
        },
        name: {
            textStyle: 'webH3',
            marginBottom: '14.5px'
        },
        address: {
            textStyle: 'bodySmRegular'
        },
        hours: {
            px: 4,
            mb: '19px',
            textStyle: 'bodyXsRegular'
        },
        availability: {
            alignItems: 'center',
            px: 4,
            mb: 4
        },
        ctas: {
            display: 'flex',
            flexWrap: 'no-wrap',
            gap: 2,
            p: {base: 4},
            borderTop: {base: '1px solid'},
            borderColor: {base: 'webTheme.strokeTertiary'},
        },
        cta: {
            flex: '1 1 0',
            minWidth: 0,
            width: 'auto',
            px: '8px',
            py: '10px',
            height: 'auto',
            minHeight: '48px',
            lineHeight: '1.2',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            whiteSpace: 'normal',
            overflowWrap: 'anywhere',
            textWrap: 'balance',
            _hover: {textDecoration: 'none'}
        }
    })
}
